import {customAxiosBE} from "../config";
import moment from "moment/moment";
import {parsePaginationParams} from "../../utils/other";

export async function putTripAPI(data) {
    return customAxiosBE.put(`/trip`, data)
}

export async function updateTripByLine(data) {
    return customAxiosBE.put(`/trip/updateTripByLine`, data)
}

export async function insertTripAPI(data) {
    return customAxiosBE.post(`/trip`, data)
}

export async function getTripByIdApi(id) {
    return customAxiosBE.get(`/trip/${id}`)
}

export async function getTripOperationalIntervalApi(tripId) {
    return customAxiosBE.get(`/trip/${tripId}/operational-interval`)
}

export async function getTripHasVehiclesByIdApi(id) {
    return customAxiosBE.get(`trip/tripHasVehicles/${id}`)
}

export async function getLinkedTripsByTripId(tripId,date) {
    return customAxiosBE.get(`trip/linked-trips/${tripId}?date=${date}`)
}

export async function getLineByTripId(id) {
    return customAxiosBE.get(`/trip/${id}/line`)
}

export async function getPricePreviewByLineIdRateCardId(data) {
    const {lineId, depStationId, rateCardId} = data
    return customAxiosBE.get(`/trip/price-preview?depStationId=${depStationId}&lineId=${lineId}&rateCardId=${rateCardId}`)
}

export async function getLinkedTripPricePreviewAPI(data) {
    const {linkID, rateCardId, stationId} = data
    return customAxiosBE.get(`/trip/price-preview-linked?linkID=${linkID}&rateCardId=${rateCardId}&stationId=${stationId}`)
}

export async function getByLineId(id) {
    return customAxiosBE.get(`/trip/byLine/${id}`)
}

export async function getByLineName(lineName) {
    try {
        return await customAxiosBE.post(`/trip/byLineName`, lineName, {
            headers: {
                'Content-Type': 'text/plain'
            }
        });
    } catch (error) {
        console.error("Error fetching trips by line name:", error);
    }
}

export async function searchTripApi(data) {
    return customAxiosBE.post(`/trip/search`, data)
}

// V2 verzija - koristi opseg datuma (from i to su obavezni)
export async function searchTripApiV2(data) {
    return customAxiosBE.post(`/trip/v2/search`, data)
}

// Dijagnostika: zašto se polazak ne vidi u v2 pretrazi prodaje (procedura check_trip_availability)
export async function checkTripAvailabilityApi(data) {
    return customAxiosBE.post(`/trip/availability-check`, data)
}

// POVRATAK IZ MESTA
export async function searchTripReturnApi(data) {
    return customAxiosBE.post(`/trip/searchTripReturn`, data)
}

export async function getAllTripTimesFromSelectedStationByOperatorApi(data) {
    return await customAxiosBE.post(`/trip/times`, data)
}

export async function postInstantTripAPI(data) {
    return await customAxiosBE.post(`/trip/instantTrip`, data)
}

export async function getAllTripByOperator(data) {
    const parsedParams = parsePaginationParams(data)
    return customAxiosBE.get(`/trip/byOperator?${parsedParams}`)
}

export async function getAllByOperatorWithStatusOfDiscount(ticketTypeId) {
    return customAxiosBE.get(ticketTypeId ? `/trip/getAllByOperatorWithStatusOfDiscount?ticketTypeId=${ticketTypeId}` : `/trip/getAllByOperatorWithStatusOfDiscount`)
}

export function deactivateWithNoteTripApi(data) {
    return customAxiosBE.put(`/trip/deactivate`, data)
}

export function activateTripApi(obj) {
    return customAxiosBE.put(`/trip/activate`, obj)
}

export function cancelTripApi(id, payload, linkId) {
    return customAxiosBE.post(
        `/trip/${id}/cancelToPeriod`,
        payload,
        { params: linkId != null ? { linkId } : undefined }
    );
}


export function getTripsByDepStationAndArrStation(depId, arrId, tripId) {
    return customAxiosBE.get(`/trip/depStation/${depId}/arrStation/${arrId}?tripId=${tripId}`)
}

export function findTripForReservation(data) {
    return customAxiosBE.post(`/trip/findTripForReservation`, data)
}

export function getTripsByDepStationAndArrStationByOperatorId(depId, arrId, operatorId) {
    return customAxiosBE.get(`/trip/depStation/${depId}/arrStation/${arrId}/operatorId/${operatorId}`)
}

export function getAllInverseReturnTrips(data) {
    return customAxiosBE.post(`/trip/allInverseReturnTrips`, data)
}

export async function insertCommentAPI(data) {
    return customAxiosBE.post(`/trip/addComment`, data)
}

export async function getCommentsAPI(id, date) {
    if (id === null || id === undefined) return {data: {}};
    return customAxiosBE.get(`/trip/${id}/info?date=${date}`)
}

export async function getEligibleForRateCardTripsAPI(rateCardId) {
    return customAxiosBE.get(`/trip/eligible-for-rate-card/${rateCardId}`)
}

export async function getItinerariesLinkedAPI(id, date, linkId) {
    if (!id) return;

    const payload = {
        tripTime: moment(date).format("YYYY-MM-DD")
    };

    const endpoint = linkId
        ? `/trip/${id}/itineraries/${linkId}`
        : `/trip/${id}/itineraries`;

    return customAxiosBE.post(endpoint, payload);
}

// DEPRECATED: bez pozivalaca (jedini je bio zakomentarisani SeatOccupation). Zauzeće se čita
// kroz allSeats (/trip/{id}/seats) i /trip-seat-status; endpoint na serveru je @Deprecated.
// export async function occupiedSeatsAPI({
//                                            tripId,
//                                            journeyDate,
//                                            fromStationId,
//                                            toStationId
//                                        }) {
//     return customAxiosBE.get(`/trip/${tripId}/seats/occupied?journeyDate=${journeyDate}&depId=${fromStationId}&arrId=${toStationId}`);
// }


export async function allSeats(data, signal) {
    const {id, date, depId, arrId} = data
    let url = `/trip/${id}/seats?date=${date}`;
    if (depId) {
        url += `&depId=${depId}`;
    }
    if (arrId) {
        url += `&arrId=${arrId}`;
    }
    return customAxiosBE.get(url, {signal});
}


export async function applyRateCardToTripsAPI(data) {
    return customAxiosBE.post(`/trip/apply-rate-card`, data)
}

export async function cancelLinkedTrips(data) {
    return customAxiosBE.post(`/trip/cancelLinkedTrips`, data)
}

// Masovni instant polasci - dohvati aktivne polaske za liniju
export async function getActiveTripsByLineAPI(lineId) {
    return customAxiosBE.get(`/trip/active-by-line/${lineId}`)
}

// Masovni instant polasci - bulk update operationalInterval
export async function bulkUpdateOperationalIntervalAPI(data) {
    return customAxiosBE.put(`/trip/bulk-update-operational-interval`, data)
}
